import apiClient from "../../utils/api.client";

/* It gets the tax conditions */
const getTaxConditions = async () => {
  try {
    const url = `gamma-accounting/taxConditions?pageNumber=1&pageSize=20&orderCriteria=ASC&orderField=name&enabled=true`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getTaxConditions EP: ", error);
    throw error;
  }
};

const accountingService = {
  getTaxConditions,
};

export default accountingService;
